import React, {
  useState,
  useRef,
  useContext
} from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import FileContext from './context';
import DescriptionIcon from '@material-ui/icons/Description';
import List from '~/containers/List';
import Request from '~/providers/Request';
import ModalDelete from '~/components/ModalDelete';
import {
  showFile,
  editFile,
  createFile
} from '~/config/routes';
import { AbilityContext } from '~/contexts/Can';
// import lodash from 'lodash';

function FileList() {
  const { t } = useTranslation();
  const [modalInfo, setModalInfo] = useState({ show: false });
  const { delRecord } = useContext(FileContext);
  const ability = useContext(AbilityContext);
  const listEl = useRef(null);

  const trAttr = (attr) => t(`files.attributes.${attr}`);

  function handleDeletionModal(id, title){
    setModalInfo({ show: true, id, title });
  }

  async function handleDelete(){
    try {
      await Request.del(`/admin/files/${modalInfo.id}`);
      delRecord(modalInfo.id);
      listEl.current.onQueryChange();
      toast.success(t('delete-toast-success'));
    } catch(e) {
      toast.error(t('delete-toast-fail'));
    } finally {
      setModalInfo({ show: false });
    }
  }

  const actions = [
    'search',
    'filter',
  ];

  if(ability.can('new', 'Files')) {
    actions.push('new');
  }
  if(ability.can('edit', 'Files')) {
    actions.push('edit');
  }
  if(ability.can('delete', 'Files')) {
    actions.push('del');
  }
  if(ability.can('show', 'Files')) {
    actions.push('show');
  }

  return (
    <div>
      <List

        deleteAction={handleDeletionModal}
        routeToNew={createFile}
        routeToEdit={editFile}
        routeToShow={showFile}
        listEl={listEl}
        path={'/admin/files/'}
        actions={actions}
        paperProps={{
          Icon: DescriptionIcon,
          iconColor: 'blue',
          title: t('files.defPlural'),
          // subtitle: 'Vídeos para aparecimento no APP'
        }}
        columns={[
          { title: trAttr('id'), field: 'id', type: 'numeric', precision: 0, includeThousandsSeparator: false },
          { title: trAttr('key'), field: 'key', type: 'string' },
          { title: trAttr('url'), field: 'url', type: 'string' },
          // { title: trAttr('pack_type'), field: 'pack_type', type: 'string' },
          // { title: trAttr('order'), field: 'order', type: 'numeric', precision: 0, includeThousandsSeparator: false },
          { title: trAttr('is_active'), field: 'is_active', type: 'boolean' },
          // { title: trAttr('created_at'), field: 'created_at', type: 'datetime' },
          // { title: trAttr('updated_at'), field: 'updated_at', type: 'datetime' },
        ]}
        context={FileContext}
        recordMap={
          record => ({
            ...record,
            // url: record.url ? lodash.truncate(record.url, { length: 50 }) : null,
            // created_at: record.created_at ? moment(record.created_at).format('DD/MM/YYYY HH:mm') : null,
            // updated_at: record.updated_at ? moment(record.updated_at).format('DD/MM/YYYY HH:mm') : null,
          })
        }
      />

      <ModalDelete
        id={modalInfo.id}
        name={modalInfo.title}
        modal={modalInfo.show}
        deleteAction={handleDelete}
        onClose={() => setModalInfo({ show: false })}
      />
    </div>
  );
}

export default React.memo(FileList);
